import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import './MovieAdd.css';

const MovieAdd = () => {
    const [genres, setGenres] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [thumbnailFile, setThumbnailFile] = useState(null);
    const [thumbnailPreview, setThumbnailPreview] = useState('');
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    const [formData, setFormData] = useState({
        title: '',
        description: '',
        director: '',
        thumbnailUrl: '',
        backgroundUrl: '',
        videoUrl: '',
        releaseDate: '',
        duration: 0,
        genreIds: []
    });

    useEffect(() => {
        const fetchGenres = async () => {
            try {
                const res = await fetch(`${baseUrl}/genres`);
                const data = await res.json();
                setGenres(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error('Error fetching genres:', err);
            }
        };
        fetchGenres();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setThumbnailFile(file);
            setFormData(prev => ({
                ...prev,
                thumbnailUrl: file.name
            }));

            // Tạo preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setThumbnailPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleGenreChange = (genreId) => {
        setFormData(prev => {
            const newGenreIds = prev.genreIds.includes(genreId)
                ? prev.genreIds.filter(id => id !== genreId)
                : [...prev.genreIds, genreId];
            return { ...prev, genreIds: newGenreIds };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const token = localStorage.getItem("jwtToken");

            const res = await fetch(`${baseUrl}/movies`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (!res.ok) {
                let errorMessage = 'Thêm phim thất bại';
                try {
                    const contentType = res.headers.get("content-type");
                    if (contentType && contentType.includes("application/json")) {
                        const errorData = await res.json();
                        errorMessage = errorData.message || errorMessage;
                    } else {
                        const errorText = await res.text();
                        errorMessage = errorText || errorMessage;
                    }
                } catch (parseErr) {
                    console.warn("Không thể parse response:", parseErr);
                }

                throw new Error(errorMessage);
            }

            Swal.fire({
                title: 'Thành công!',
                text: 'Phim đã được thêm thành công!',
                icon: 'success',
                confirmButtonText: 'OK'
            }).then(() => {
                window.location.href = "/admin";
            });

        } catch (err) {
            Swal.fire({
                title: 'Lỗi',
                text: err.message || 'Có lỗi xảy ra khi thêm phim',
                icon: 'error',
                confirmButtonText: 'Đóng'
            });

            setError(err.message);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="admin-dashboard">

            <div className="back-button-container">
                <Link to="/admin" className="back-button">
                    &larr; Quay về trang quản trị
                </Link>
            </div>

            <div className="movie-add-container">
                <h1>Thêm phim mới</h1>

                {error && <div className="error-message">{error}</div>}

                <form onSubmit={handleSubmit} className="movie-form">
                    <div className="form-group">
                        <label>
                            Tiêu đề phim *
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                required
                                maxLength={100}
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            Mô tả
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                maxLength={1000}
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            Đạo diễn
                            <input
                                type="text"
                                name="director"
                                value={formData.director}
                                onChange={handleChange}
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            Hình ảnh (thumbnail) *
                            <div className="thumbnail-upload">
                                <input
                                    type="file"
                                    id="thumbnail"
                                    accept="image/*"
                                    onChange={handleThumbnailChange}
                                    required
                                />
                                {thumbnailPreview && (
                                    <div className="thumbnail-preview">
                                        <img src={thumbnailPreview} alt="Thumbnail preview" />
                                        <span>{formData.thumbnailUrl}</span>
                                    </div>
                                )}
                            </div>
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            URL Background *
                            <input
                                type="url"
                                name="backgroundUrl"
                                value={formData.backgroundUrl}
                                onChange={handleChange}
                                required
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            URL video *
                            <input
                                type="url"
                                name="videoUrl"
                                value={formData.videoUrl}
                                onChange={handleChange}
                                required
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            Ngày phát hành
                            <input
                                type="date"
                                name="releaseDate"
                                value={formData.releaseDate}
                                onChange={handleChange}
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>
                            Thời lượng (phút) *
                            <input
                                type="number"
                                name="duration"
                                value={formData.duration}
                                onChange={handleChange}
                                min="1"
                                required
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>Thể loại</label>
                        <div className="genre-checkboxes">
                            {genres.map(genre => (
                                <div key={genre.id} className="genre-checkbox">
                                    <input
                                        type="checkbox"
                                        id={`genre-${genre.id}`}
                                        checked={formData.genreIds.includes(genre.id)}
                                        onChange={() => handleGenreChange(genre.id)}
                                    />
                                    <label htmlFor={`genre-${genre.id}`}>{genre.name}</label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="form-actions">
                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={() => window.location.href = "/admin"
                            }
                            disabled={loading}
                        >
                            Hủy bỏ
                        </button>
                        <button
                            className="submit-btn"
                            disabled={loading}
                        >
                            {loading ? 'Đang xử lý...' : 'Thêm phim'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default MovieAdd;